// extracted by mini-css-extract-plugin
export default {"table-head":"TableHead_table-head__h1bYg","item":"TableHead_item__ccgq9"};